import React from 'react';
import Text from 'antd/lib/typography/Text';
import { AppComponentProps } from '../../typescriptHelpers';
import Layout from 'antd/lib/layout';
import { Content } from 'antd/lib/layout/layout';
import { MobileSideBarHeader } from './mobileComponents/MobileSideBarHeader';
import { useIsMobile } from '../../mediaQueriesHelpers';
import { titleStyle } from '../styles/globalStyles';
import Space from 'antd/lib/space';
import Spin from 'antd/lib/spin';

export interface DesktopAndMobileHeaderProps extends AppComponentProps {
    title: string;
    children: React.ReactNode | ((isMobile: boolean) => React.ReactNode);
    topRightComponent?: React.ReactNode;
    topLeftComponent?: React.ReactNode | ((titleComponent: React.ReactNode) => React.ReactNode);
    isLoading?: boolean;
    titleFontSize?: number;
    headerComponent?: React.ReactNode;
}

export const DesktopAndMobileHeader: React.FC<DesktopAndMobileHeaderProps> = ({
    title,
    appId,
    orgId,
    children,
    topRightComponent,
    topLeftComponent,
    isLoading,
    titleFontSize,
    headerComponent,
}) => {
    const isMobile = useIsMobile();
    const titleComponent = (
        <Text ellipsis style={{ ...titleStyle, fontSize: titleFontSize ?? 16 }} type="secondary">
            {title}
        </Text>
    );

    return (
        <MobileSideBarHeader
            orgId={orgId}
            appId={appId}
            title={title}
            topRightComponent={topRightComponent}
            topLeftComponent={topLeftComponent}
        >
            <Layout
                style={{
                    overflow: 'scroll',
                    marginBottom: isMobile ? 0 : 24,
                }}
            >
                <Content
                    style={{
                        padding: isMobile ? 0 : '22px 36px',
                        display: 'flex',
                        gap: 12,
                        flexDirection: 'column',
                        ...(isMobile && {
                            height: 0,
                        }),
                    }}
                >
                    {isLoading ?
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                width: '100%',
                                flexGrow: 1,
                            }}
                        >
                            <Spin />
                        </div>
                    :   <>
                            {headerComponent}
                            {!isMobile && (
                                <div
                                    style={{
                                        display: 'flex',
                                        width: '100%',
                                        justifyContent: 'space-between',
                                        alignItems: 'start',
                                        marginBottom: 16,
                                    }}
                                >
                                    {typeof topLeftComponent === 'function' ?
                                        topLeftComponent(titleComponent)
                                    :   <Space>
                                            {titleComponent}
                                            {topLeftComponent}
                                        </Space>
                                    }
                                    {topRightComponent}
                                </div>
                            )}
                            {typeof children === 'function' ? children(isMobile) : children}
                        </>
                    }
                </Content>
            </Layout>
        </MobileSideBarHeader>
    );
};
